<script lang="ts" setup>
import Size from 'gpcore-uikit/interfaces/Size';
import SinglePageLayout from './Layout.SinglePage.vue';
import TabbarItem from 'gpcore-uikit/components/Component.Tabbar.Item.vue';
import Tabbar from 'gpcore-uikit/components/Component.Tabbar.vue';
import { useRoute } from 'vue-router';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import Toolbar from 'gpcore-uikit/components/Component.Toolbar.vue';

withDefaults(
  defineProps<{
    tabBarActionsClass?: string;
    contentSize?: Size;
  }>(),
  {
    tabBarActionsClass: '',
    contentSize: Size.Large,
  },
);

const projectStore = useProjectStore();
const currentProjectId = projectStore.project.id;

const route = useRoute();
</script>

<template>
  <SinglePageLayout :content-size="contentSize">
    <template #titlebar>
      <Toolbar title="Images" />
    </template>
    <template #tabbar>
      <Tabbar>
        <TabbarItem
          :active="route.name === 'ProjectImages'"
          :to="{ name: 'ProjectImages', params: { projectId: currentProjectId } }"
          title="Project images"
        />
        <TabbarItem
          :active="route.name === 'PublicImages'"
          :to="{ name: 'PublicImages' }"
          title="Public images"
        />

        <template #tabbarActions>
          <div class="tw-flex tw-gap-4" :class="tabBarActionsClass">
            <slot name="buttons" />
          </div>
        </template>
      </Tabbar>
    </template>
    <template #content>
      <main>
        <slot name="content" />
      </main>
    </template>
  </SinglePageLayout>
</template>
